export default __webpack_public_path__ + "static/link-item-icon-do-023a6b9edb92decb58301a305f91bc0c4bfdc1970f809a7ffc0785cb21ac767a.png";